import { render } from "./bonusItem.vue?vue&type=template&id=f5a05a6a&scoped=true"
import script from "./bonusItem.vue?vue&type=script&lang=js"
export * from "./bonusItem.vue?vue&type=script&lang=js"

import "./bonusItem.vue?vue&type=style&index=0&id=f5a05a6a&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a05a6a"]])

export default __exports__